



































































import moment from 'moment';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {TransactionOperations} from '@/enums/TransactionOperations';
import TransactionsApi from '@/apis/TransactionsApi';
import TransactionChangeDetailsRequestModel from '@/models/transactions/TransactionChangeDetailsRequestModel';

@Component({
        name: 'TransactionChangeDetails',
    },
)
export default class TransactionChangeDetails extends ViewBase {
    @Prop({default: 0, required: true})
    public transactionId!: number;
    @Prop({default: 0, required: true})
    public bankAccountId!: number;
    @Prop({default: 0, required: true})
    public fundId!: number;

    public transactionDescription: string = '';
    public transactionDate: string = '';
    public checkNumber: string = '';
    public transactionDateMenu: boolean = false;
    public authorized: boolean = false;

    public transactionDescriptionRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A transaction description is required.';
        }

        return true;
    }

    public created() {
        if ( this.$store.state.selectedTransaction.authorizedOperations & TransactionOperations.CHANGE_DETAILS )
        {
            this.authorized = true;
            this.transactionDate = moment(this.$store.state.selectedTransaction.transactionDate).format('YYYY-MM-DD');
            this.transactionDescription = this.$store.state.selectedTransaction.transactionDescription;
            this.checkNumber = this.$store.state.selectedTransaction.checkNumber;
        }
    }

    public async saveClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new TransactionChangeDetailsRequestModel();
                request.transactionDate = new Date(this.transactionDate);
                request.transactionDescription = this.transactionDescription;
                request.checkNumber = this.checkNumber;

                const api = new TransactionsApi();
                const response = await api.changeDetailsAsync(this.bankAccountId, this.transactionId, this.$store.state.member.jwt, request);

                await this.$router.push({
                    name: 'transactiondashboard',
                    params: {
                        bankAccountId: this.bankAccountId.toString(10),
                        fundId: this.fundId.toString(10),
                        transactionId: this.transactionId.toString(10),
                    },
                });
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.changeDetailsForm;

        return form.validate();
    }

}

